<!-- Daily Deals -->
<section class="daily-deals mb-4" >
    <div class="daily-deals-products">
        <div class="row">
            <div class="col-lg-6  mb-3"  *ngFor="let offer of offers;let i=index">
                
                <div class="deals-product position-relative">

                    <div class="product-img mb-3 text-center">
                        <img src="{{offer.product.images[0].image}}" alt="" class="img-fluid img-fit">
                    </div>
                    <div class="product-title px-3">
                        <h6 class="text-truncate text-white">{{offer.name_en}}</h6>
                    </div>
                    <div class="product-info overflow-hidden p-3">
                        <span class="category rounded-pill px-2">{{offer.type}}</span>
                        <span class="text-secondary-color font-weight-bold float-right product-price"> {{offer.description_en}} </span>
                    </div>
                </div>
            </div>
           

        </div>
    </div>
</section>
<!-- ./Daily Deals -->